export default __webpack_public_path__ + "static/media/trophy.83bba181.webp";